// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JIRw","title":"styles_title__2GNSj"};